export * from './affiche/affiche.component';
export * from './rendez-vous/rendez-vous.component';
export * from './rendez-vous/rendez-vous.module';
export * from './rendez-vous-formateur/rendezvousformateur.component';
export * from './rendez-vous-formateur/rendezvousformateur.module';
export * from './reservation/reservation.component';
export * from './reservation/reservation.module';
export * from './reservation-formateur/reservationformateur.component';
export * from './reservation-formateur/reservationformateur.module';
export * from './reservation-stagiaire/reservationstagiaire.component';
export * from './reservation-stagiaire/reservationstagiaire.module';
export * from './reservation-stagiaire/reservationstagiaire.pipe';

export * from './action-co/action-co.module';
export * from './action-co/action-co.component';

export * from './taches/taches.module';
export * from './taches/taches.component';

export * from './conges/conges.module';
export * from './conges/conges.component';

export * from './postit/postit.module';
export * from './postit/postit.component';
//////export * from './select/select.component';
export * from './agenda.component';
export * from './agenda.module';
export * from './agenda.queoval.services';
